import { hasProActiveGreetingsTriggered, getIdleTimeout, hasCalloutBubbleGreetingsTriggered, isChatNotStarted } from '@/services/utils'
import { setCookie, removeCookie } from '@/services/cookie'
import { constantStrings, cookieConstant } from '@/services/constants'
import { isUserLoggedIn, blankScreenCheck, renderCalloutBubble } from '../../services/utils'
import store from '@/store'

export default {
    setCalloutBubbleConfig({ commit }, config) {
      commit('UPDATE_CALLOUT_BUBBLE_CONFIG_PUBSUB', config)
      renderCalloutBubble()
    },

    triggerProActiveGreetings({ dispatch, rootState }, isEndGreeting = false) {
        if (store.getters.isPromptTestingEnable || (!isEndGreeting && rootState?.widgetConfig?.proactiveTriggerType === 'staticMenu')) {
          return
        }
        let proActiveGreetings = []
        // proactive greeting trigger after ending chat
        const idleTimeout = getIdleTimeout()
        if (isEndGreeting) {
          proActiveGreetings = rootState.widgetConfig.sessionRestartGreeting
          if (isValidOrigin(rootState.widgetConfig?.proActiveGreetingsProtocols)) {
            dispatch('sendProactiveGreetingUtterancesWithEndGreeting', proActiveGreetings)
            return true
          }
          return false
        }
        if (!hasProActiveGreetingsTriggered()) {
          const isValid = handleAlertsAndTerms('proactive', rootState, dispatch)
          if (isValid) return
          proActiveGreetings = rootState.widgetConfig?.proActiveGreetings
          if(proActiveGreetings && isValidOrigin(rootState.widgetConfig?.proActiveGreetingsProtocols) && eitherChatNotStartedOrUserLoggedIn()) {
            if(isUserLoggedIn()) {
              dispatch('showMessageSeparator', { //TODO: Remove this dispatch when history will have info regarding session end in it.
                isMessageSeparator: true,
                content: {
                  component: 'EndChatSeparator',
                  message: 'New Conversation Started',
                  isEndChatSeparator: true
                },
                timestamp: Date.now()
              }
              )
            } 
            setCookie(cookieConstant.GREETING.PROACTIVE_GREETING_COOKIE_LABEL, true,  { SameSite: 'None', Secure: 'true', 'max-age': idleTimeout / 1000 })
            dispatch('sendProactiveGreetingUtterances', proActiveGreetings)
            // Check for blank screen after few seconds
            blankScreenCheck(constantStrings.EMPTY_PROACTIVE_RESPONSE)
          }
        } 
    },

    triggerCalloutBubbleGreetings({ dispatch, rootState }) {
      if (store.getters.isKnowledgeAiEnabled) {
        return
      }
      let calloutBubbleIntent = rootState.widgetConfig?.calloutBubble?.intent
      if (calloutBubbleIntent && !hasCalloutBubbleGreetingsTriggered() && isChatNotStarted()) {
        const isValid = handleAlertsAndTerms('calloutbubble', rootState, dispatch)
        if (isValid) return
        setCookie(cookieConstant.GREETING.CALLOUT_BUBBLE_GREETING_COOKIE_LABEL, true,  {})
        dispatch('sendMessage', {
          userMessage: {
            payload: calloutBubbleIntent,
            label: constantStrings.CALLOUT_BUBBLE_TEXT
          }
        })
        // Check for blank screen after few seconds
        blankScreenCheck(constantStrings.EMPTY_CALLOUT_RESPONSE)
      }
    },

    sendProactiveGreetingUtterances({  dispatch }, data) {
        data.map(message => {
          dispatch('sendMessage', {
            userMessage: {
              payload: message,
              label: constantStrings.PROACTIVE_GREETING_LABEL,
              hideMessage: true
            }
          })
        })
    },

    sendProactiveGreetingUtterancesWithEndGreeting({  dispatch }, data) {
      data.map(message => {
        dispatch('sendMessage', {
          userMessage: {
            payload: message,
            label: constantStrings.PROACTIVE_GREETING_LABEL,
            hideMessage: true
          },
          isEndGreeting : true,
        })
      })
  },

    DELETE_PROACTIVE_GREETING_COOKIE() {
        removeCookie(cookieConstant.GREETING.PROACTIVE_GREETING_COOKIE_LABEL, { SameSite: 'None', Secure: 'true' })
    },
}

const isValidOrigin = (protocols) => {
  const protocol = window.parent.location.protocol
  return protocols ? protocols.includes(protocol) : protocol === constantStrings.HTTPS
}

const eitherChatNotStartedOrUserLoggedIn = () => {
  return isChatNotStarted() || isUserLoggedIn()
}

const handleAlertsAndTerms = (triggerType, rootState, dispatch) => {
  const isHighPriorityAlertValid = Object.keys(rootState.alerts.highPriorityAlert).length
  const isMediumPriorityAlertValid = Object.keys(rootState.alerts.mediumPriorityAlert).length
  const isTermsValid = Object.keys(rootState.termsAndConditions.terms).length
  if (isHighPriorityAlertValid || isMediumPriorityAlertValid || isTermsValid) {
    if ((isHighPriorityAlertValid && !isTermsValid) || isMediumPriorityAlertValid) {
      dispatch('updateGreetingTriggerOnAlertClosureState', triggerType)
    }
    if ((isTermsValid && !isMediumPriorityAlertValid)) {
      dispatch('updateGreetingTriggerOnTermsClosureState', triggerType)
    }
    return true
  }
  return false
}
